"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var merge = exports.merge = function merge() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return _extends.apply(undefined, [{}].concat(args));
};

var push = exports.push = function push(array) {
  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return [].concat(_toConsumableArray(array), args);
};

var removeByIndex = exports.removeByIndex = function removeByIndex(array, index) {
  return [].concat(_toConsumableArray(array.slice(0, index)), _toConsumableArray(array.slice(index + 1)));
};

var remove = exports.remove = function remove(array, item) {
  var index = array.indexOf(item);
  var result = [].concat(_toConsumableArray(array));
  if (index !== -1) {
    result = removeByIndex(array, index);
  }
  return result;
};

var modifyByIndex = exports.modifyByIndex = function modifyByIndex(array, index, func) {
  var result = [].concat(_toConsumableArray(array));
  if (index && func) {
    result = [].concat(_toConsumableArray(array.slice(0, index)), [func(array[index])], _toConsumableArray(array.slice(index + 1)));
  }
  return result;
};

var modify = exports.modify = function modify(array, item, func) {
  var index = array.indexOf(item);
  var result = [].concat(_toConsumableArray(array));
  if (index !== -1) {
    result = modifyByIndex(array, index, func);
  }
  return result;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/util/lib/immutable.js
 ** module id = 513
 ** module chunks = 0
 **/